interface BrazilFlagProps {
  size?: number;
}

export default function BrazilFlag({ size = 24 }: BrazilFlagProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden='true'>
      <g clipPath='url(#clip0_288_28409)'>
        <path
          d='M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z'
          fill='#6DA544'
        />
        <path d='M12 4.69568L21.913 12L12 19.3044L2.08697 12L12 4.69568Z' fill='#FFDA44' />
        <path
          d='M12 16.1739C14.3052 16.1739 16.1739 14.3052 16.1739 12C16.1739 9.69483 14.3052 7.82611 12 7.82611C9.69482 7.82611 7.82611 9.69483 7.82611 12C7.82611 14.3052 9.69482 16.1739 12 16.1739Z'
          fill='#F0F0F0'
        />
        <path
          d='M9.91303 11.7391C9.18722 11.7391 8.48677 11.8495 7.82742 12.0544C7.85663 14.3344 9.71306 16.1739 12 16.1739C13.4141 16.1739 14.6631 15.47 15.4181 14.3942C14.1263 12.7771 12.1388 11.7391 9.91303 11.7391Z'
          fill='#0052B4'
        />
        <path
          d='M16.0965 12.7997C16.1468 12.5408 16.1739 12.2736 16.1739 12C16.1739 9.69478 14.3052 7.82611 12 7.82611C10.28 7.82611 8.80345 8.86678 8.16445 10.3526C8.7293 10.2356 9.31411 10.1739 9.91313 10.1739C12.3374 10.1739 14.5305 11.1816 16.0965 12.7997Z'
          fill='#0052B4'
        />
      </g>
      <defs>
        <clipPath id='clip0_288_28409'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
